import { Button, Drawer } from 'antd';
import { Form, Formik } from 'formik';
import { observer } from 'mobx-react-lite';
import React, { Dispatch, SetStateAction } from 'react';
import { DEFAULT_PAGE_SIZE } from '../../../../../config/config';
import { PermissionEvaluations } from '../../../../../permissions/PermissionEvaluations';
import NotPermissionComponent from '../../../../atoms/NotPermissionComponent';
import SelectComponent from '../../../../atoms/SelectComponent';
import Permission from '../../../../molecules/Permission';
import orderBonusStore from '../../../../../stores/orderBonusStore';
import { removeWhitespace } from '../../../../../utils/functions';
import orderStore from '../../../../../stores/orderStore';

export const statusOptions = [
    {
        value: 'APPROVED',
        label: 'Aprovado'
    },
    {
        value: 'DECLINED',
        label: 'Reprovado'
    }
];


const paramsDefault = {
    size: DEFAULT_PAGE_SIZE,
    page: 0,
    sort: 'created,desc',
};


interface DrawerOrderBonusProps {
    isModalOpen: boolean;
    setIsModalOpen: Dispatch<SetStateAction<boolean>>;
    order: any;
}

const DrawerOrderBonus: React.FC<DrawerOrderBonusProps> = observer(({ setIsModalOpen, isModalOpen, order }: any) => {
    const disabled = order.bonusStatus === 'APPROVED' || order.bonusStatus === 'DECLINED';

    const handleSubmit = async (values: { status: any }) => {
        const status = removeWhitespace(values.status.value);
        const response = await orderBonusStore.updateStatusBonus(order?.uuid, status);

        if (!response?.error) {
            if (status === 'DECLINED') {
                changeOrderDetails();
            };
            orderBonusStore.getList(paramsDefault);
            setIsModalOpen(false);
        }
    };

    const changeOrderDetails = async () => {
        await orderStore.changeOrderStatus('CANCELED', order?.uuid, order?.customer?.uuid);
    }

    const initialValuesForm = {
        status: { value: order.bonusStatus === 'PENDING' ? null : order.bonusStatus, label: order.bonusStatus === 'PENDING' ? null : order.bonusStatus },
    };

    return (
        <Permission
            permissionKeys={[PermissionEvaluations.GET_UUID]}
            fallback={NotPermissionComponent()}
        >
            <Formik initialValues={initialValuesForm} onSubmit={handleSubmit} enableReinitialize>
                {({ submitForm }) => ( // Aqui está o submitForm
                    <Drawer
                        title="Atualização de Pedido"
                        width={540}
                        onClose={() => setIsModalOpen(false)}
                        open={isModalOpen}
                        footer={
                            <div className="flex gap-4 justify-end">
                                <Button onClick={() => setIsModalOpen(false)}>Cancelar</Button>

                                <Permission permissionKeys={[PermissionEvaluations.PUT]} buttonType>
                                    <Button disabled={disabled} type="primary" onClick={submitForm}> {/* Agora funciona */}
                                        Atualizar
                                    </Button>
                                </Permission>
                            </div>
                        }
                    >
                        <Form>
                            <div className="flex gap-4 flex-col">
                                <SelectComponent disabled={disabled} label="Aprovar Pedido Bonus" size="middle" name="status" options={statusOptions} />
                            </div>
                        </Form>
                    </Drawer>
                )}
            </Formik>
        </Permission>
    );
});

export default DrawerOrderBonus;
